import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRatingScalesAction } from "../actions";
import { getLoading, getData, getTypeList, getTargetList } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { RESET_STATE } from "../actionTypes";
import { getFiltersIsLoading } from "@icarius-common/filtersDialog/selectors";

const useRatingScales = () => {
    const [createRatingScaleIsOpen, setCreateRatingScaleIsOpen] = useState(false);
    const typeList = useSelector(getTypeList);
    const targetList = useSelector(getTargetList);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getRatingScalesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const isLoadingLocal = useSelector(getLoading);
    const filtersIsLoading = useSelector(getFiltersIsLoading);
    const isLoading = isLoadingLocal || filtersIsLoading;

    return {
        color,
        data,
        typeList,
        targetList,
        isLoading,
        createRatingScaleIsOpen,
        setCreateRatingScaleIsOpen,
    };
};

export default useRatingScales;
